import React, { forwardRef } from 'react'

import { Message as IMessage } from 'Types'

interface Props {
  customerId: string
  message: IMessage
}

const Message = forwardRef<HTMLLIElement, Props>(({ message, customerId }, ref) => {
  const { body, timestamp, associableId } = message
  const isCustomer = message.authorId == customerId
  const sendAt = timestamp.toDate()
  const sendAtFormatted = sendAt.toLocaleString()

  return (
    <li ref={ref} className={`chatBox__dialog--message ${isCustomer ? 'msgTo' : 'msgFrom'}`} id={message.id}>
      <div className="chatBox__dialog--message-body">
        <p>{body || `${associableId}`}</p>
      </div>
      <span className="chatBox__dialog--message-info">{sendAtFormatted}</span>
    </li>
  )
})

Message.displayName = 'Message'

export default Message
